import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { DistributionService } from '../../../modules/services/distribution.service';
import { CommonModule } from '@angular/common';
import { initFlowbite } from 'flowbite';
import { HttpErrorResponse } from '@angular/common/http';
import { getMonthName } from '../../helpers/helper';
import { ApiResponse } from '../../services/types/api-schema.types';
import { environment } from '../../../../environments/environment';
import { DashboardService } from '../../../modules/services/dashboard.service';
import { AMCDistributionService } from '../../../modules/services/amc.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, CommonModule, RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent implements OnInit {
  listSidebarYear: any[] = [];
  categories: any[] = [];
  selectedCategoryIndex: number | null = null;
  clickedYearIndex: number | null = null;
  showCategories: boolean = false;
  tokenYears: any[] = []; // For storing Token Distribution Years and Months
  showTokenYears: boolean = false; // Toggle for Token Distribution years menu
  selectedTokenYearIndex: number | null = null; // To track selected year index for Token Distribution
  showTokenYearsHistory: boolean = false;
  selectedTokenHistoryYearIndex: number | null = null;
  showAMCTokenDistributionMenu: boolean = false;
  showAMCTokenYears: boolean = false; // Toggle for Token Distribution years menu
  selectedAMCTokenYearIndex: number | null = null; // To track selected year index for Token Distribution
  showAMCTokenYearsHistory: boolean = false;
  selectedAMCTokenHistoryYearIndex: number | null = null;
  protected auditReportLink = environment.AUDIT_REPORT_LINK;
  isSubMenuOpen: boolean = false;
  isDistributionUserMenuOpen: boolean = false;
  amctokenYears: any[] = [];

  constructor(
    private readonly distributionService: DistributionService,
    private readonly amcDistributionService: AMCDistributionService,
    private readonly router: Router,
    private readonly dashboardService: DashboardService
  ) { }

  ngOnInit(): void {
    initFlowbite();
    this.getAllCategories();
    this.getTokenDistributionYears(); // Fetch Token Distribution Data
    this.getAMCTokenDistributionYears()
    this.listenNavigationEnd();

  }

  /**
   * Closes all dropdown menus and resets their states.
   */
  closeAllMenus() {
    this.isDistributionUserMenuOpen = false;
    this.showTokenYears = false;
    this.selectedTokenYearIndex = null;
    this.showTokenYearsHistory = false;
    this.selectedTokenHistoryYearIndex = null;
    this.isSubMenuOpen = false;
    this.showAMCTokenDistributionMenu = false;
  }


  /**
   * Retrieves all categories from the server and stores them in the component's categories array.
   * 
   * This function is called in ngOnInit() to populate the categories array when the component is initialized.
   * 
   * The function logs the response and any errors to the console.
   */
  getAllCategories() {
    this.distributionService.getDistributionCategories().subscribe({
      next: (res: ApiResponse<any>) => {
        this.categories = res.data;
      },
      error: (err: HttpErrorResponse) => {
        console.error('Failed to get categories', err);
      }
    });
  }

  /**
   * Toggles the visibility of the categories dropdown and resets the selected category index when clicked.
   * 
   * The selected category index is set to null when the categories dropdown is closed.
   * 
   * This function is called when the categories dropdown button is clicked.
   */
  getDistributionCategories() {
    this.showCategories = !this.showCategories;
    this.selectedCategoryIndex = null;
  }

  /**
   * Handles the selection of a category from the categories dropdown.
   * 
   * @param index The index of the selected category in the categories array.
   * @param id The id of the selected category.
   * 
   * When a category is selected, this function toggles the selected category index and fetches the available years and months for the selected category.
   * If the selected category index is null (i.e., the same category is selected again), the function does nothing.
   * 
   * This function is called when a category is selected from the categories dropdown.
   */
  selectCategory(index: number, id: string) {

    this.selectedCategoryIndex = this.selectedCategoryIndex === index ? null : index;
    if (this.selectedCategoryIndex !== null) {
      this.fetchYearsAndMonths(id);
    }
  }

  /**
   * Fetches the available years and months for a given category id.
   * 
   * @param categoryId The id of the category for which to fetch the available years and months.
   * 
   * The function subscribes to the observable returned by the {@link DistributionService.getDistributionYearsAndMonthsByCategoryId} method and stores the list of years in the component's listSidebarYear property.
   * 
   * The function is called when a category is selected from the categories dropdown.
   */
  fetchYearsAndMonths(categoryId: string) {
    this.distributionService.getDistributionYearsAndMonthsByCategoryId(categoryId).subscribe({
      next: (res: ApiResponse<any>) => {
        console.log('Years:', res);
        this.listSidebarYear = res.data.year_list;
        this.distributionService.updateYearList(this.listSidebarYear);

      },
      error: (err: HttpErrorResponse) => {
        console.error('Failed to fetch years', err);
      }
    });
  }

  /**
   * Toggles the selected year index when a year is clicked.
   * 
   * @param index The index of the year in the listSidebarYear array.
   * 
   * If the same year is clicked again, the selected year index is reset to null.
   * 
   * Logs the selected year index to the console.
   */
  selectYear(index: number) {
    this.clickedYearIndex = this.clickedYearIndex === index ? null : index;
  }


  /**
   * Returns the month name for a given index (0 for January, 11 for December).
   * @param index - The index of the month (0-11).
   * @returns The name of the month or 'Invalid month' if the index is out of range.
   */
  getMonths(index: number) {
    return getMonthName(index);
  }


  /**
 * Toggles the visibility of the Token Distribution years menu.
 */
  toggleAMCTokenDistributionMenu() {
    if (this.showAMCTokenYears) {
      this.showAMCTokenYears = false;
      this.selectedAMCTokenYearIndex = null;
    } else {
      this.isDistributionUserMenuOpen = false;
      this.showTokenYears = false;
      this.selectedTokenYearIndex = null;
      this.showTokenYearsHistory = false;
      this.selectedTokenHistoryYearIndex = null;
      this.isSubMenuOpen = false;
      // this.showAMCTokenDistributionMenu=false;
      this.showAMCTokenYears = true;
    }
  }

  toogleAMCChampainMenu() {
    if (this.showAMCTokenDistributionMenu) {
      this.showAMCTokenDistributionMenu = false;
      this.closeAllMenus();
    } else {
      this.closeAllMenus();
      this.showAMCTokenDistributionMenu = true;
    }

  }

  toggleTokenDistributionMenu() {
    if (this.showTokenYears) {
      this.showTokenYears = false;
      this.selectedTokenYearIndex = null;
    } else {
      this.showTokenYears = true;
    }
  }


  /**
   * Fetches the Token Distribution years and months from the service.
   */
  getTokenDistributionYears() {
    this.distributionService.getTokenDistributionYears().subscribe({
      next: (res: ApiResponse<any>) => {
        this.tokenYears = res.data;
        this.distributionService.updateYearList(this.tokenYears);
      },
      error: (err: HttpErrorResponse) => {
        console.error('Failed to fetch Token Distribution years', err);
      }
    });
  }

  /**
 * Fetches the Token Distribution years and months from the service.
 */
  getAMCTokenDistributionYears() {
    this.amcDistributionService.getACMTokenDistributionYears().subscribe({
      next: (res: ApiResponse<any>) => {
        this.amctokenYears = res.data;
        this.amcDistributionService.updateAMCYearList(this.amctokenYears);
      },
      error: (err: HttpErrorResponse) => {
        console.error('Failed to fetch Token Distribution years', err);
      }
    });
  }

  /**
 * Handles the selection of a Token Distribution year.
 *
 * @param index The index of the selected year.
 * @param year The year object.
 */
  selectTokenYear(index: number, year: any) {
    this.selectedTokenYearIndex = this.selectedTokenYearIndex === index ? null : index;
  }

  selectAMCTokenYear(index: number, year: any) {
    this.selectedAMCTokenYearIndex = this.selectedAMCTokenYearIndex === index ? null : index;
  }


  /**
   * Toggles the visibility of the Token Distribution history menu.
   */
  toggleTokenDistributionHistoryMenu() {
    if (this.showTokenYearsHistory) {
      this.showTokenYearsHistory = false;
      this.selectedTokenHistoryYearIndex = null;
    } else {
      this.closeAllMenus();
      this.showTokenYearsHistory = true;
    }
  }

  /**
   * Toggles the visibility of the AMC Token Distribution history menu.
   */
  toggleAMCTokenDistributionHistoryMenu() {
    if (this.showAMCTokenYearsHistory) {
      this.showAMCTokenYearsHistory = false;
      this.selectedTokenHistoryYearIndex = null;
    } else {
      this.showAMCTokenYearsHistory = true;
    }
  }

  /**
* Handles the selection of a Token Distribution year.
*
* @param index The index of the selected year.
* @param year The year object.
*/
  selectTokenHistoryYear(index: number, year: any) {
    this.selectedTokenHistoryYearIndex = this.selectedTokenHistoryYearIndex === index ? null : index;
  }

  /**
* Handles the selection of a AMC Token Distribution year.
*
* @param index The index of the selected year.
* @param year The year object.
*/
  selectAMCTokenHistoryYear(index: number, year: any) {
    this.selectedAMCTokenHistoryYearIndex = this.selectedAMCTokenHistoryYearIndex === index ? null : index;
  }

  toggleSubMenu() {
    if (this.isSubMenuOpen) {
      this.isSubMenuOpen = false;
    } else {
      this.closeAllMenus();
      this.isSubMenuOpen = true;
    }
  }

  toggleDistributionUserMenu() {
    if (this.isDistributionUserMenuOpen) {
      this.isDistributionUserMenuOpen = false;
    } else {
      this.closeAllMenus();
      this.isDistributionUserMenuOpen = true;
    }
  }


  /**
   * @description
   * Emits an event to the {@link DashboardComponent} to open the distribution report page.
   * This function is called when a year is selected from the token distribution history menu.
   */
  yearSelected() {
    this.dashboardService.changeValue(true);
  }

  /**
   * Listens for the NavigationEnd event and handles the following:
   * - If the url starts with '/token-distribution-details/', it sets the showTokenYears flag to true and sets the selectedTokenYearIndex based on the year in the url.
   * - If the url starts with '/token-distribution-history/', it sets the showTokenYearsHistory flag to true and sets the selectedTokenHistoryYearIndex based on the year in the url.
   * - If the url starts with '/distribution-user-data/', it sets the isDistributionUserMenuOpen flag to true.
   * - If the url is '/usdt-transfer', '/usdt-transaction-history', or '/usdt-failed-transaction-history', it sets the isSubMenuOpen flag to true.
   * */
  listenNavigationEnd() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.closeAllMenus();
        const url = this.router.url;
        if (url.startsWith('/token-distribution-details/')) {
          const match = url.match(/\/token-distribution-details\/(\d+)\/(\d+)/);
          if (match) {
            const yearStr = match[1];
            const yearIndex = this.tokenYears.findIndex(y => y.year.toString() === yearStr);
            if (yearIndex !== -1) {
              this.showTokenYears = true;
              this.selectedTokenYearIndex = yearIndex;
            }
          }
        } else if (url.startsWith('/token-distribution-history/')) {
          const match = url.match(/\/token-distribution-history\/(\d+)\/(\d+)\/2/);
          if (match) {
            const yearStr = match[1];
            const yearIndex = this.tokenYears.findIndex(y => y.year.toString() === yearStr);
            if (yearIndex !== -1) {
              this.showTokenYearsHistory = true;
              this.selectedTokenHistoryYearIndex = yearIndex;
            }
          }
        } else if (url.startsWith('/distribution-user-data/') || url.startsWith('/all-distribution-user-data')) {
          this.isDistributionUserMenuOpen = true;
        } else if (url === '/usdt-transfer' || url === '/usdt-transaction-history' || url === '/usdt-failed-transaction-history') {
          this.isSubMenuOpen = true;
        } else if (
          url.startsWith('/amc-user-data') ||
          url === '/amc-global-distribution-history' ||
          url.startsWith('/amc-token-distribution-details/') ||
          url.startsWith('/amc-token-distribution-history/')
        ) {
          this.showAMCTokenDistributionMenu = true;
        }

        if (url.startsWith('/amc-token-distribution-details/')) {
          this.showAMCTokenYears = true;
          const match = url.match(/\/amc-token-distribution-details\/(\d+)\/(\d+)/);
          if (match) {
            const yearStr = match[1];
            const yearIndex = this.amctokenYears.findIndex((y: any) => y.year.toString() === yearStr);
            if (yearIndex !== -1) {
              this.selectedAMCTokenYearIndex = yearIndex;
            }
          }
        }
        else if (url.startsWith('/amc-token-distribution-history/')) {
          this.showAMCTokenYearsHistory = true;
          const match = url.match(/\/amc-token-distribution-history\/(\d+)\/(\d+)\/2/);
          if (match) {
            const yearStr = match[1];
            const yearIndex = this.amctokenYears.findIndex((y: any) => y.year.toString() === yearStr);
            if (yearIndex !== -1) {
              this.selectedAMCTokenHistoryYearIndex = yearIndex;
            }
          }
        } else if (url === '/amc-distribution-execution') {
          this.showAMCTokenDistributionMenu = true;
          const match = url.match(/\/amc-distribution-execution\/(\d+)\/(\d+)\/2/);
          if (match) {
            const yearStr = match[1];
            const yearIndex = this.amctokenYears.findIndex((y: any) => y.year.toString() === yearStr);
            if (yearIndex !== -1) {
              this.selectedAMCTokenHistoryYearIndex = yearIndex;
            }
          }

        }
      }
    });
  }



}